import React from 'react'
import AlertMessagge from '../alertMessagge/alertMessagge'
import Button from '../../../shared/components/atoms/Button/Button'
import './modalCoverage.scss'
import WarningIcon from '../../../shared/assets/images/icon-advertencia.svg'
import LayoutModal from '../../../shared/components/organisms/layoutModal/layout-modal'
import { convertText } from '../../../shared/utils/convertFirstCharacterToUppercase'

const DEFAULTA_DATA = {
	message: '¡Lo sentimos!',
	description:
		'No tenemos cobertura en tu zona para que recibas la muestra gratis. Debes ingresar una dirección donde nuestra marca tenga cobertura.',
	buttonLabel: 'ACTUALIZAR MI DIRECCIÓN',
}

const ModalCoverage = ({
	actionAlert,
	message = DEFAULTA_DATA.message,
	description = DEFAULTA_DATA.description,
	buttonLabel = DEFAULTA_DATA.buttonLabel,
}) => {
	return (
		<LayoutModal>
			<div className='f-alert-wrapper f-modal-coverage'>
				<AlertMessagge
					icon={<img src={WarningIcon} alt='warning-icon' />}
					messagge={message}
					description={description}
					type='primary'
					button={
						<Button
							type='button'
							text={convertText(buttonLabel)}
							onClickAction={actionAlert}
							classname='f-button f-button--primary'
						/>
					}
				/>
			</div>
		</LayoutModal>
	)
}

export default ModalCoverage
